"use client";
import dynamic from 'next/dynamic';
import styles from "./SoMe.module.css";
import ErrorBoundary from "@/components/framework/errorboundary/ErrorBoundary";

//#region [Props]
type TikTokProps = {
    value: {
        tiktokUserId: string;
        tiktokVideoId: string;
    }
};
//#endregion

//#region [Component]
const DynamicTikTokEmbed = dynamic(() =>
    import('react-social-media-embed').then((mod) => mod.TikTokEmbed),
    { ssr: false }
);

export default function TikTok({ value }: TikTokProps) {
    if (!value?.tiktokUserId || !value?.tiktokVideoId) {
        return null;
    }
    return <div className={styles.container}>
        <ErrorBoundary>
            <DynamicTikTokEmbed url={`https://www.tiktok.com/${value.tiktokUserId}/video/${value.tiktokVideoId}`} width="100%" />
        </ErrorBoundary>
    </div>;
}
//#endregion